const szerokosc = { t: 'Szerokość', name: 'szerokosc', hint: { url: '/part_width' }}
export default szerokosc